/* eslint-disable @repo/internal/react/no-class-components */
import React from 'react';
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError(_) {
    // Update state so the next render will show the fallback UI.
    return {
      hasError: true
    };
  }
  componentDidCatch(error, errorInfo) {
    this.props.onError && this.props.onError(error);
  }
  render() {
    if (this.state.hasError) {
      return this.props.fallback ? /*#__PURE__*/React.createElement(React.Fragment, null, this.props.fallback) : null;
    }
    return this.props.children;
  }
}
export default ErrorBoundary;